import { MilestoneListingDto } from "../../milestones/milestones.objects";

export class MilestoneDialog {

    milestoneStatusList: any[];
    successCallback: (response) => void;
    isReadOnly = false;

    constructor(milestoneStatusList, isReadOnly = false) {
        this.milestoneStatusList = milestoneStatusList;
        this.setViewType(isReadOnly);
        this.initialize();
    }

    initialize() {
        $('#editMilestoneDialog .ctms-button-save').on('click', this.saveDialog.bind(this));

        // Only relevant if editing
        if (!this.isReadOnly) {
            const self = this;
            $('#MilestoneStartedDate').on('change', function () { self.handleMilestoneFieldChange(); });
            $('#MilestoneCompletedDate').on('change', function () { self.handleMilestoneFieldChange(); });
            $('#CTMSOperationMilestoneStatusId').on('change', function () { self.handleMilestoneFieldChange(); });
        }
    }

    //Clear MilestoneCompletedDate if StartedDate is after CompletedDate or Status is "Not Started" or "Started"
    handleMilestoneFieldChange() {
        const startedDate = ($('#MilestoneStartedDate').val() || '').toString();
        const completedDate = ($('#MilestoneCompletedDate').val() || '').toString();
        const status = $('#CTMSOperationMilestoneStatusId').val();

        // If status is "Not Started" (1) or "Started" (2), clear and set completed date to readonly
        //if (status == 1 || status == 2) {
        //    $('#MilestoneCompletedDate').val('');
        //    $('#MilestoneCompletedDate').prop('readonly', true);
        //    return;
        //} else {
        //    $('#MilestoneCompletedDate').prop('readonly', false);
        //}

        // If both dates are set, and startedDate > completedDate, disable save
        if (startedDate && completedDate && startedDate > completedDate) {
            // $('#MilestoneCompletedDate').val('');
            $('#validation-error-milestone').removeClass('d-none');
            $('#editMilestoneDialog .ctms-button-save').prop('disabled', true);
        } else {
            $('#validation-error-milestone').addClass('d-none');
            $('#editMilestoneDialog .ctms-button-save').prop('disabled', false);
        }
    }

    setViewType(isReadOnly: boolean) {
        this.isReadOnly = isReadOnly;

        if (this.isReadOnly) {
            $('#editMilestoneDialog .ctms-button-save').hide();
            $('#editMilestoneDialog .ctms-button-cancel').text('Close');
        } else {
            $('#editMilestoneDialog .ctms-button-save').show()
            $('#editMilestoneDialog .ctms-button-cancel').text('Cancel');
        }
    }

    resetDialog(milestone: MilestoneListingDto) {

        if (milestone == null) return;

        $('#MilestoneName').text(milestone.MilestoneCategoryAndName);
        $('#validation-error-milestone').addClass('d-none');

        if (this.isReadOnly) {
            $('#MilestoneStartedDateRO').text(milestone.StartedDate);
            $('#MilestoneDueDateRO').text(milestone.ExpectedDueDate);
            $('#MilestoneNotesRO').text(milestone.Notes);
            const status = this.milestoneStatusList.find(s => s.Id === milestone.CTMSOperationMilestoneStatusId);
            $('#MilestoneStatusRO').text(status ? status.Name : '');
            $('#MilestoneCompletedDateRO').text(milestone.CompletionDate);

            if (!milestone.NotApplicable) {
                $('#MilestoneNotApplicableLabel').hide();
            }

            $('#siteMilestoneForm .ctms-field-submit').hide();
            $('#siteMilestoneForm .ctms-form-text').show();
        } else {
            const f = document.getElementById('siteMilestoneForm') as HTMLFormElement;
            f.reset();
            $('#siteMilestoneForm').removeClass('ctms-invalid-form');

            $('#MilestoneNotApplicable').prop('checked', milestone.NotApplicable);

            $('#MilestoneId').val(milestone.Id);

            $('#MilestoneStartedDate').val(milestone.StartedDate);

            $('#MilestoneDueDate').val(milestone.ExpectedDueDate);
            // status
            const options = this.milestoneStatusList.map((s) => new Option(s.Name, s.Id.toString()));
            $('#CTMSOperationMilestoneStatusId').empty();
            $('#CTMSOperationMilestoneStatusId').append(options);
            $('#CTMSOperationMilestoneStatusId').val(milestone.CTMSOperationMilestoneStatusId);

            $('#MilestoneNotes').val(milestone.Notes);
            $('#MilestoneCompletedDate').val(milestone.CompletionDate);

            $('#siteMilestoneForm .ctms-field-submit').show();
            $('#siteMilestoneForm .ctms-form-text').hide();
        }
        this.handleMilestoneFieldChange();
    }

    saveDialog(evt: JQuery.ClickEvent) {
        const token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');
        const f = document.getElementById('siteMilestoneForm') as HTMLFormElement;

        //if ($('#MilestoneNotApplicable').prop('checked')) {
        //    $('#MilestoneDueDate').removeAttr('required');
        //    $('#MilestoneDueDate').val('');
        //} else {
        //    $('#MilestoneDueDate').prop('required', true);
        //}

        if (f.checkValidity()) {
            $.ajax({
                url: `/secure/ctms/sites/site-details?handler=UpdateMilestone`,
                headers: { "RequestVerificationToken": token },
                type: 'POST',
                data: $('#siteMilestoneForm .ctms-field-submit').serialize(),
                success: (resp) => {
                    if (this.successCallback) this.successCallback(resp);
                    $('#editMilestoneDialog').modal('hide');
                }
            });
        } else {
            $('#siteMilestoneForm').addClass('ctms-invalid-form');
        }

        evt.preventDefault();
        evt.stopPropagation();
    }

}